<template>
    <div>
        <h5>Resources</h5>

        <div class="card">

            <div class="formgrid">
                <div class="">
                    <label for="code">Theme Help Link</label>
                    <InputText id="code" type="text" v-model="themeHelpLink" autofocus class="w-full"
                         placeholder="e.g https://www.exp.com/theme-help-link" />

                </div>
            </div>

            <small v-if="error" class="text-danger">
                {{ error }}
            </small>

            <div class="mt-3">
                <Button class="btn btn-primary" @click="savePreference" :disabled="saving">
                    {{ saving ? 'Saving...' : 'Save' }}
                </Button>
            </div>

        </div>
    </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue'
import { useAuthStore } from '@/modules/auth/store';
import { authApi } from '@/utilities/axios';
import { showToast } from '@/utilities/toast-handler';



const authStore = useAuthStore();


const themeHelpLink = ref('')
const loading = ref(false)
const saving = ref(false)
const error = ref('')
const companyId = computed(() => authStore.getLoggedUserCompanyId);

const BASE_URL = `${process.env.VUE_APP_API_URL}/${process.env.VUE_APP_API_VERSION}/admin/company`
// simple URL validation
const isValidUrl = (url) => {
    try {
        new URL(url)
        return true
    } catch {
        return false
    }
}

// fetch existing value
const fetchPreference = async () => {
    loading.value = true

    try {
       
        return authApi
            .get(`${BASE_URL}/${companyId.value}/theme-help-link`)
            .then((response) => {
                    themeHelpLink.value = response.data?.value || ''
                }
            )
       
    } catch (e) {
        error.value = 'Failed to load data'
    } finally {
        loading.value = false
    }
}

// save value
const savePreference = async () => {
    error.value = ''

    if (themeHelpLink.value && !isValidUrl(themeHelpLink.value)) {
        error.value = 'Please enter a valid URL'
        return
    }

    saving.value = true

    try {
        const response = await authApi.post(
            `${BASE_URL}/${companyId.value}/theme-help-link`,
            {
                value: themeHelpLink.value,
                company_id: companyId.value
            }
        )

        if( response?.statusCode === 200 ){
            showToast({ severity: 'success', summary: 'Success' }, 'Saved successfully');
        }

    } catch (e) {
        error.value = 'Failed to save'
        showToast(e, 'Failed to save Theme Help Link')
    } finally {
        saving.value = false
    }
}

onMounted(() => {
    fetchPreference()
})
</script>
